import { Component, OnInit } from '@angular/core';
import { DateFormatter } from '@ddt-web/data-service';
import { DateUtil, InjectQueryParam, InjectSessionStorage, SessionStorageKey } from '@ddt-web/generic-utils';
import { SharedQueryParamKey } from '@ddt-web/url';

@Component({
	selector: 'pas-preview-data-banner',
	templateUrl: './preview-data-banner.component.html',
	styleUrls: ['./preview-data-banner.component.scss']
})
export class PreviewDataBannerComponent implements OnInit {
	@InjectQueryParam(SharedQueryParamKey.PAS_PREVIEW) public readonly pasPreview: boolean;
	@InjectQueryParam(SharedQueryParamKey.PAS_AS_OF_DATE) private readonly pasAsOfDateOverrideQp: string;
	@InjectSessionStorage(SessionStorageKey.PAS_AS_OF_DATE) private readonly pasAsOfDateOverrideSession: string;
	private readonly asOfDateRegex = new RegExp(/^\d{4}-\d{2}-\d{2}$/);
	public showBanner = true;

	public asOfDate;
	public showAsOfDate = false;

	public ngOnInit(): void {
		this.setAsOfDate();
	}

	public toggleBanner(): void {
		this.showBanner = !this.showBanner;
	}

	private setAsOfDate(): void {
		const pasAsOfDate = this.pasAsOfDateOverrideQp || this.pasAsOfDateOverrideSession;
		if (pasAsOfDate) {
			if (this.asOfDateRegex.test(pasAsOfDate)) {
				this.asOfDate = new DateFormatter(DateUtil.MODELS_US_DATE_FORMAT).format(pasAsOfDate);
				this.showAsOfDate = true;
			}
		}
	}
}
